// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IRawStyle, ITheme } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { HighContrastSelector, memoizeFunction } from "@fluentui/react";

import {
  baseFabricFocusSelector,
  commonHighContrastFocusedDisabledStyles,
  commonHighContrastHoverFocusStyles,
  commonHighContrastOutlineFocusedDisabled,
  commonHighContrastOutlineHoverFocus,
  commonMenuItemHighContrastOutlineHoverFocus,
} from "./commonStyles";
import type { StandardControlSemanticColors } from "./standardControlSemanticColors";
import { getStandardControlSemanticColorsWithTheme } from "./standardControlSemanticColors";
import { getInnerBorderStyles } from "./getInnerBorderStyles";
export const getCommonIsFocusVisibleStyles = memoizeFunction(
  (theme: ITheme): IRawStyle[] => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const style = [
      {
        selectors: {
          ":after": [
            getInnerBorderStyles({
              width: 2,
              color: standardControlSemanticColors.focusedBorderColor,
              gap: -1,
            }),
            { [HighContrastSelector]: { border: "none" } },
          ],
        },
      },
      commonHighContrastOutlineHoverFocus,
      commonHighContrastHoverFocusStyles,
    ];
    return style;
  }
);

export const getCommonMenuItemIsFocusVisibleStyles = memoizeFunction(
  (theme: ITheme): IRawStyle[] => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const style = [
      {
        selectors: {
          ":after": [
            getInnerBorderStyles({
              width: 2,
              color: standardControlSemanticColors.focusedBorderColor,
              gap: -1,
            }),
            { [HighContrastSelector]: { border: "none" } },
          ],
        },
      },
      commonMenuItemHighContrastOutlineHoverFocus,
      commonHighContrastHoverFocusStyles,
    ];
    return style;
  }
);

export const getCommonDisabledIsFocusVisibleStyles = memoizeFunction(
  (theme: ITheme): IRawStyle[] => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const style = [
      {
        backgroundColor: standardControlSemanticColors.disabledBackgroundColor,
        selectors: {
          ":after": [
            getInnerBorderStyles({
              width: 2,
              color: standardControlSemanticColors.focusedBorderColor,
              gap: -1,
            }),
            { [HighContrastSelector]: { border: "none" } },
          ],
        },
      },
      commonHighContrastOutlineFocusedDisabled,
      commonHighContrastFocusedDisabledStyles,
    ];
    return style;
  }
);

export const getCommonActiveStyles = memoizeFunction(
  (theme: ITheme): IRawStyle[] => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const style = [
      {
        backgroundColor: standardControlSemanticColors.pressedBackgroundColor,
        color: standardControlSemanticColors.textColor,
      },
      commonHighContrastOutlineHoverFocus,
      commonHighContrastHoverFocusStyles,
    ];
    return style;
  }
);

export const commonMozFocusInnerStyles = {
  border: "0",
};

export const getButtonStateStyles = memoizeFunction(
  (theme: ITheme, expanded?: boolean, disabled?: boolean): IRawStyle => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    if (expanded) {
      return {
        backgroundColor: standardControlSemanticColors.expandedBackgroundColor,
        color: standardControlSemanticColors.textColor,
        selectors: {
          ":focus": {
            outline: "0",
          },
          ":hover": {
            backgroundColor:
              standardControlSemanticColors.expandedBackgroundColor,
            color: standardControlSemanticColors.textColor,
          },
          [`${baseFabricFocusSelector}, &:focus`]: disabled
            ? getCommonDisabledIsFocusVisibleStyles(theme)
            : getCommonIsFocusVisibleStyles(theme),
        },
      };
    }
    return {
      selectors: {
        ":hover": {
          backgroundColor: standardControlSemanticColors.hoverBackgroundColor,
          color: standardControlSemanticColors.textColor,
        },
        ":focus": {
          outline: "0",
        },
        [`${baseFabricFocusSelector}, &:focus`]: disabled
          ? getCommonDisabledIsFocusVisibleStyles(theme)
          : getCommonIsFocusVisibleStyles(theme),
        ":active": getCommonActiveStyles(theme),
        "::-moz-focus-inner": commonMozFocusInnerStyles,
      },
    };
  }
);
